import { AnyDocument } from '../../../types';
import { ConstructGet } from '../../types/ConstructGet';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { DOCUMENTS_BASE_PATH } from '../constants/documentsBasePath';
import { buildHeadersFromDocumentParams } from '../logic/buildHeadersFromDocumentParams';
import { DocumentParams } from '../types/DocumentParams';

export const getDocumentSelector = async <T>(
  constructGet: ConstructGet,
  documentParams: DocumentParams,
  documentId: AnyDocument['id'],
  selector: string,
): Promise<NonPaginatedResponse<T> | undefined> =>
  constructGet<NonPaginatedResponse<T>>(
    `${DOCUMENTS_BASE_PATH}/${documentId}/selector/${selector}`,
    {
      headers: buildHeadersFromDocumentParams(documentParams),
    },
  );
